import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { setApiRole, authApi } from '../api/api';
import { checkUserAuth, clearUserAuth, updateActivity, TOKEN_KEYS } from '../utils/tokenUtils';

const PrivateUserRoute = ({ children }) => {
  const [authStatus, setAuthStatus] = useState('checking');
  const [shouldRedirect, setShouldRedirect] = useState(false);

  useEffect(() => {
    setApiRole('user');
    
    // Set up activity tracking
    const handleActivity = () => updateActivity();
    const events = ['mousemove', 'keydown', 'mousedown', 'touchstart'];
    events.forEach(event => window.addEventListener(event, handleActivity));

    // Check authentication status
    const checkAuth = async () => {
      const authResult = checkUserAuth();
      
      if (authResult.isAuthenticated) {
        setAuthStatus('authenticated');
        updateActivity();
        return;
      }
      
      if (authResult.needsRefresh) {
        try {
          const refreshToken = localStorage.getItem(TOKEN_KEYS.USER_REFRESH);
          const response = await authApi.post('/auth/refresh', { refreshToken });
          
          // Store new tokens
          localStorage.setItem(TOKEN_KEYS.USER_ACCESS, response.data.accessToken);
          localStorage.setItem(TOKEN_KEYS.USER_REFRESH, response.data.refreshToken);
          updateActivity();
          
          setAuthStatus('authenticated');
          return;
          
        } catch (error) {
          console.error('❌ User token refresh failed:', error);
          clearUserAuth();
        }
      }
      
      // Authentication failed
      clearUserAuth();
      setAuthStatus('unauthenticated');
      setShouldRedirect(true);
    };

    checkAuth();

    // Cleanup event listeners
    return () => {
      events.forEach(event => window.removeEventListener(event, handleActivity));
    };
  }, []);

  // Show loading state while checking authentication
  if (authStatus === 'checking') {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        fontSize: '18px',
        color: '#666'
      }}>
        🔐 Verifying authentication...
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (shouldRedirect || authStatus === 'unauthenticated') {
    return <Navigate to="/consultant" replace />;
  }

  // Render protected content
  return children;
};

export default PrivateUserRoute;
